define('Components/AboutNavByDesireWidget/js/views/EmptyChildView',[
    'underscore',
    'WidgetInstanceView',
],
    function(_,
             WidgetInstanceView){
        return WidgetInstanceView.extend({
            getTemplate:function(){
                return _.template('');
            },
        })
    }
);
